var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetworkTension(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.576 9.1555C31.296 9.0715 31.824 10.9555 32.616 16.5235C33.336 21.5635 34.272 26.5555 35.22 31.5595C35.856 34.8835 37.872 40.5475 34.548 42.8995C31.536 45.0355 24.096 45.7195 20.46 46.0075C14.772 46.4515 14.46 44.2915 13.632 39.1555C12.828 34.2235 12.012 29.3035 11.232 24.3715C10.74 21.2515 8.87999 15.7075 10.812 12.7435C13.044 9.3235 24.576 9.1555 24.576 9.1555Z",
    fill: "#5A87FF",
    stroke: "#5A87FF",
    strokeWidth: 0.684,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.24 14.3279C12.888 23.3759 14.736 30.2879 15.288 34.8359C15.312 35.0879 15.768 37.6199 15.936 37.8119C15.936 37.8119 16.296 37.8719 16.716 37.8119C21.684 37.0799 28.176 36.0719 33.144 35.3519C32.076 25.8719 31.236 21.7199 29.22 11.8799C25.464 12.2759 12.24 14.3279 12.24 14.3279Z",
    fill: "#101C1E",
    stroke: "#101C1E",
    strokeWidth: 0.588,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.28 40.3679C26.448 41.2319 25.896 42.0599 25.044 42.2159C24.18 42.3839 23.352 41.8319 23.184 40.9679C23.016 40.1039 23.58 39.2879 24.432 39.1199C25.296 38.9519 26.112 39.504 26.28 40.356V40.3679Z",
    fill: "#FEDC5D",
    stroke: "#FEDC5D",
    strokeWidth: 0.852,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.619 17.8325C19.512 18.26 20.0745 20.1905 21.303 20.078C21.303 20.078 21.708 20.078 22.086 19.6505C22.8375 18.8 21.726 17.405 20.619 17.8325ZM21.762 19.259C21.393 19.5875 20.988 19.511 20.799 19.25C20.61 18.989 20.511 18.377 20.9295 18.26C21.4875 18.1025 22.1355 18.926 21.7665 19.259H21.762Z",
    fill: "#FEDC5D",
    stroke: "#FEDC5D",
    strokeWidth: 0.342,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.138 31.4445C25.6995 31.5615 25.668 29.604 24.8805 29.2935C24.093 28.983 23.328 29.253 23.0985 30.0045C22.869 30.756 23.4765 31.395 24.138 31.4445Z",
    fill: "#FF931E",
    stroke: "#FF931E",
    strokeWidth: 0.342,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.296 27.0839C27.774 26.9444 27.414 26.0534 26.6805 23.3354C25.947 20.6174 23.94 18.8984 21.4245 19.4969L21.2355 19.5464C18.7605 20.2934 17.8875 22.7864 18.621 25.5089C19.3545 28.2269 19.494 29.1764 19.1115 29.5589C18.729 29.9414 18.9405 30.5759 20.124 30.4769C22.7295 30.2564 26.406 29.1629 28.044 28.2449C28.89 27.7724 28.7325 27.1964 28.2915 27.0794L28.296 27.0839Z",
    fill: "#FEDC5D",
    stroke: "#FEDC5D",
    strokeWidth: 0.342,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5715 25.8057C21.3975 25.2567 24.192 24.5412 26.8695 23.4702C24.399 24.9687 21.4515 25.7247 18.5715 25.8057Z",
    fill: "#FF931E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.792 26.7242C21.618 26.1752 24.4125 25.4597 27.09 24.3887C24.6195 25.8872 21.672 26.6432 18.792 26.7242Z",
    fill: "#FF931E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9655 27.7637C30.177 28.5602 29.826 29.4647 29.169 29.9462C29.547 29.2487 29.8215 28.5422 29.9655 27.7637Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.023 26.9263C31.572 28.3078 30.924 29.9728 29.718 30.7828C30.6315 29.7118 31.185 28.3483 31.023 26.9263Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8525 22.8811C16.56 22.1116 16.803 21.1756 17.4105 20.6221C17.1135 21.3556 16.911 22.0891 16.8525 22.8811Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8895 23.826C15.192 22.512 15.66 20.7885 16.7715 19.8525C15.9795 21.018 15.579 22.431 15.8895 23.826Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkTension);
export default __webpack_public_path__ + "static/media/network-tension.a123d66b7988fa6234a0638a515e6b4c.svg";
export { ForwardRef as ReactComponent };